import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface TextLoaderProps {
  messageKey?: string;
}

export function TextLoader(props: any): JSX.Element {
  const { i18n } = useTranslation();

  return (
    <Typography variant="h3" sx={{
      animation: 'loading 4s linear infinite',
      background: "linear-gradient(to right, #bbb 10%, #333 40%, #333 50%, #bbb 90%)",
      backgroundSize: "200% auto",
      backgroundClip: "text",
      textFillColor: "transparent",
      '@keyframes loading': {
        to: {
          backgroundPosition: '-200% center',
        }
      },
    }}>
      {i18n.t(props.messageKey || "loading")}...
    </Typography>
  );
}